// API client da feature Dobra de Nicho. Reusa o padrao axios + Bearer do app.
import axios from 'axios';

const API = `${import.meta.env.VITE_BACKEND_URL}/api`;

const auth = () => ({
  headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
});

// Inicia uma analise (gate + cota no backend). force=true => "Analisar de novo".
// lang = idioma do usuario (a ANALISE/explicacoes saem nele).
export async function startAnalysis(channelInput, force = false, lang = 'pt') {
  const { data } = await axios.post(
    `${API}/dobra-nicho/analyze`,
    { channel_id_or_url: channelInput, force_refresh: force, lang },
    auth(),
  );
  return data; // { job_id, status, reused }
}

// Historico: analises concluidas do usuario (reabrir via getStatus).
export async function listAnalyses() {
  const { data } = await axios.get(`${API}/dobra-nicho/analyses`, auth());
  return data.analyses || [];
}

// [Comunidade descontinuada] listCommunity/searchCommunity foram removidos: a aba
// Comunidade foi desativada e as rotas /dobra-nicho/community(/search) desregistradas.
// Cada análise é individual; o reuso entre usuários acontece no /analyze (cache).

// SOFT-delete: tira da lista do usuario (a analise FICA salva no sistema).
export async function hideAnalysis(jobId) {
  const { data } = await axios.delete(`${API}/dobra-nicho/${jobId}`, auth());
  return data;
}

// Polling do job.
export async function getStatus(jobId) {
  const { data } = await axios.get(`${API}/dobra-nicho/status/${jobId}`, auth());
  return data; // { status, progress, message, result, ... }
}

// Expansao lazy de uma oportunidade (Prompt 2). Subnicho/Nova Visao/Adaptacao
// => relatorio completo. Dobra => apenas o FRAME (4 nichos SEM titulos); os
// titulos vêm por nicho via expandNiche (progressivo).
export async function expandOpportunity(analysisId, opportunityIndex) {
  const { data } = await axios.post(
    `${API}/dobra-nicho/${analysisId}/expand`,
    { opportunity_index: opportunityIndex },
    auth(),
  );
  return data; // { opportunity_index, tipo, report, cached }
}

// Titulos de UM nicho-alvo de uma Dobra (chamado em paralelo, progressivo).
export async function expandNiche(analysisId, opportunityIndex, nicheIndex) {
  const { data } = await axios.post(
    `${API}/dobra-nicho/${analysisId}/expand-niche`,
    { opportunity_index: opportunityIndex, niche_index: nicheIndex },
    auth(),
  );
  return data; // { niche_index, nome, titulos, mapa_de_equivalencia, cached }
}
